<template>
  <div
    :class="getClass"
    class="top-menu">
    <div
      v-if="showEnvironment"
      :class="environmentClass"
      class="environment">
      {{ environment }}
    </div>
    <div class="fixed-content">
      <IconLink
        v-if="!noBack"
        :class-name="{'d-block': true, 'backButton': true, 'activeIcon': darkBackground}"
        :to="backTo"
        icon="fas fa-chevron-left"
        @click="$emit('click')"/>
      <span class="font-weight-bold non-selectable-text">{{ title }}</span>
      <IconLink
        v-if="!noMenu"
        :class-name="{'d-block': true, 'menuButton': true}"
        icon="fas fa-bars"
        @click="$store.commit('menu/showSideMenu', true)"/>
    </div>
  </div>
</template>

<script>
import IconLink from '@/components/Utils/IconLink';
import config from '@/config';

export default {
  name: 'TopMenu',
  components: {
    IconLink,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    backTo: {
      type: String,
      default: '/',
    },
    noBack: {
      type: Boolean,
      default: false,
    },
    noMenu: {
      type: Boolean,
      default: false,
    },
    noBackground: {
      type: Boolean,
      default: false,
    },
    darkBackground: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    environment() {
      return config.ENV.ID;
    },
    environmentClass() {
      return {
        'environment-red': this.environment === 'QA',
        'environment-green': this.environment === 'UAT',
        'environment-yellow': this.environment === 'DEV',
      };
    },
    showEnvironment() {
      return this.environment && this.environment !== 'PROD';
    },
    getClass() {
      let c = 'background-color';
      if (this.noBackground) c = 'no-background-color';
      else if (this.darkBackground) c = 'dark-background-color';
      return c;
    },
  },
  methods: {},
};
</script>

<style scoped lang="scss">
div {
  &.top-menu {
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 1001;
    padding: 11px 0;
  }

  .no-background-color {
    background-color: transparent;
    color: $base;
  }

  .background-color {
    background-color: $base;
    color: $primary;
  }

  .dark-background-color {
    background-color: $primary;
    color: $base;
  }

  &.environment {
    opacity:0.7;
    padding: 9px;
    position: absolute;
    top: 0px;
  }

  &.environment-red {
    color: red;
    border: 2px solid red;
    background-color: white;
  }

  &.environment-green {
    color: green;
    border: 2px solid green;
    background-color: white;
  }

  &.environment-yellow {
    color: orangered;
    border: 2px solid orangered;
    background-color: white;
  }
}
</style>
